module.exports = "<p>\n  pagenotfound works!\n</p>\n"